import {
    DeleteButton,
    SaveButton,
    Toolbar as Ratoolbar,
    ToolbarProps, useRecordContext
} from 'react-admin';
import { ComponentProps, ComponentType, PropsWithChildren } from 'react';
import { Box, Stack } from '@mui/material';

const Toolbar: ComponentType<
    PropsWithChildren<
        ToolbarProps & {
            showDelete?: boolean;
            disableSave?: boolean;
            mutationMode?: ComponentProps<typeof DeleteButton>['mutationMode'];
        }
    >
> = ({ disableSave, mutationMode = 'pessimistic', ...props }) => {
    const showDelete =
        typeof props.showDelete === 'boolean' ? props.showDelete : true;
    const { children, className, resource } = props;

    return (
        <Ratoolbar {...props}>
            {showDelete && (
                <DeleteButton resource={resource} mutationMode={mutationMode} />
            )}
            <Box flex={1} />
            <Stack spacing={1} direction={'row'} alignItems={'center'}>
                {children}
                <SaveButton disabled={disableSave} />
            </Stack>
        </Ratoolbar>
    );
};
export default Toolbar;
